/**
 * Copyright (c) HashiCorp, Inc.
 */

import { and } from 'ember-truth-helpers';

import CutTextWithIcon from '../text-with-icon.gts';

import type { TOC } from '@ember/component/template-only';
import type { CutTextWithIconSignature } from '../text-with-icon.gts';

export interface MetadataInServiceMeshSignature {
  Args: {
    connectedWithGateway?: boolean;
    connectedWithProxy?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: CutTextWithIconSignature['Element'];
}

const MetadataInServiceMesh: TOC<MetadataInServiceMeshSignature> = <template>
  {{#if (and @connectedWithGateway @connectedWithProxy)}}
    {{! TODO: add translate(CC-5314) }}
    <CutTextWithIcon
      @icon="mesh"
      @text="in service mesh with proxy and gateway"
      data-test-mesh
    />

  {{else if @connectedWithProxy}}
    {{! TODO: add translate(CC-5314) }}
    <CutTextWithIcon
      @icon="mesh"
      @text="in service mesh with proxy"
      data-test-mesh
    />

  {{else if @connectedWithGateway}}
    {{! TODO: add translate(CC-5314) }}
    <CutTextWithIcon
      @icon="mesh"
      @text="in service mesh with gateway"
      data-test-mesh
    />
  {{/if}}
</template>;

export default MetadataInServiceMesh;
